import { render, staticRenderFns } from "./DetailDeposit.vue?vue&type=template&id=77232e69&"
import script from "./DetailDeposit.vue?vue&type=script&lang=ts&"
export * from "./DetailDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./DetailDeposit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/NVME/projects/vbimex/gubuy/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
